import React, { FC } from 'react';
import { formatClassName } from '../../utils';
import { DataAttributes } from '../../utils/pickDataAttributes';
import { Button } from '../Button';
import { IconCategoryValue } from '../icon-category-value';
import { kebabCase } from 'lodash';

export interface Props {
  canClose?: boolean;
  category?: string;
  data?: object;
  disabled?: boolean;
  onClick?: () => void;
  onRemove?: () => void;
  sortable?: boolean;
  value?: string;
}

export interface DataObject {
  action?: string;
  objectId?: string | number;
  objectType?: string;
  componentType?: string;
}

export const Chip: FC<Props> = ({
  canClose = true,
  category,
  data = {},
  disabled,
  onClick,
  onRemove = () => {},
  sortable,
  value,
  ...props
}) => {
  // @ts-ignore
  const getChipClasses = (): string | undefined => formatClassName(['legacy-chip', { disabled }]);

  const getDataAttributes = (data: DataObject): object => {
    const dataProps: DataAttributes = {};
    if (data.action) {
      dataProps['data-action'] = data.action;
    }
    if (data.objectId) {
      dataProps['data-object-id'] = data.objectId;
    }
    if (data.objectType) {
      dataProps['data-object-type'] = data.objectType;
    }
    if (data.componentType) {
      dataProps['data-component-type'] = data.componentType;
    } else {
      dataProps['data-component-type'] = value ? `${kebabCase(value)}-chip` : 'chip';
    }
    return dataProps;
  };

  const performOnMouseDown = (event: React.MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();
  };

  const performOnClick = (event: React.MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled && onClick) {
      onClick();
    }
  };

  const performOnRemove = (event: React.MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled) {
      onRemove();
    }
  };

  const dataAttributes = getDataAttributes(data);
  return (
    <div
      className={getChipClasses()}
      tabIndex={onClick && 0}
      onMouseDown={performOnMouseDown}
      onClick={performOnClick}
      {...props}
      {...dataAttributes}
    >
      <IconCategoryValue icon={sortable ? 'grip-lines' : undefined} category={category} value={value} />
      {/* @ts-ignore */}
      {canClose && (
        <Button rightIcon="xmark" style="link" disabled={disabled} onClick={performOnRemove} renderAsLegacy />
      )}
    </div>
  );
};

Chip.displayName = 'Chip';
